import { render, staticRenderFns } from "./dialogAddseries.vue?vue&type=template&id=54d5822b&scoped=true&"
import script from "./dialogAddseries.vue?vue&type=script&lang=js&"
export * from "./dialogAddseries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5822b",
  null
  
)

export default component.exports